// extracted by mini-css-extract-plugin
export var modal = "_ej-0";